import { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';
import type { RingFinish } from '@jouzen/ecom-components/v3/types/ringFinish';
import type { MessageKey } from 'types/LocaleMessageKey';

import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { RingStyle } from '@/app/types/ring';

const TITLE_BY_STYLE_AND_FINISH: Record<
  RingStyleEnum,
  Partial<Record<RingFinishEnum, MessageKey>>
> = {
  [RingStyleEnum.Heritage]: {
    [RingFinishEnum.Black]: 'pdp_seo_title_heritage_black',
    [RingFinishEnum.Gold]: 'pdp_seo_title_heritage_gold',
    [RingFinishEnum.Silver]: 'pdp_seo_title_heritage_silver',
    [RingFinishEnum.Stealth]: 'pdp_seo_title_heritage_stealth',
  },
  [RingStyleEnum.Horizon]: {
    [RingFinishEnum.Black]: 'pdp_seo_title_horizon_black',
    [RingFinishEnum.Gold]: 'pdp_seo_title_horizon_gold',
    [RingFinishEnum.Rose]: 'pdp_seo_title_horizon_rosegold',
    [RingFinishEnum.Silver]: 'pdp_seo_title_horizon_silver',
    [RingFinishEnum.Stealth]: 'pdp_seo_title_horizon_stealth',
    [RingFinishEnum.Titanium]: 'pdp_seo_title_horizon_titanium',
  },
  [RingStyleEnum.OuraRing4]: {
    [RingFinishEnum.Black]: 'pdp_seo_title_or4_black',
    [RingFinishEnum.BrushedSilver]: 'pdp_seo_title_or4_brushed_silver',
    [RingFinishEnum.Gold]: 'pdp_seo_title_or4_gold',
    [RingFinishEnum.RoseGold]: 'pdp_seo_title_or4_rose_gold',
    [RingFinishEnum.Silver]: 'pdp_seo_title_or4_silver',
    [RingFinishEnum.Stealth]: 'pdp_seo_title_or4_stealth',
  },
  [RingStyleEnum.Ceramic]: {
    [RingFinishEnum.Midnight]: 'pdp_seo_title_or4_black',
    [RingFinishEnum.Tide]: 'pdp_seo_title_or4_black',
    [RingFinishEnum.Petal]: 'pdp_seo_title_or4_black',
    [RingFinishEnum.Cloud]: 'pdp_seo_title_or4_black',
  },
};

const DESCRIPTION_BY_STYLE: Record<RingStyleEnum, MessageKey> = {
  [RingStyleEnum.Heritage]: 'pdp_seo_description_heritage',
  [RingStyleEnum.Horizon]: 'pdp_seo_description_horizon',
  [RingStyleEnum.OuraRing4]: 'pdp_seo_description_horizon',
  [RingStyleEnum.Ceramic]: 'pdp_seo_description_horizon',
};

const getPdpWizardSeoMetadata = (
  style: RingStyle,
  finish: RingFinish = RingFinishEnum.Silver,
): {
  title: MessageKey;
  description: MessageKey;
} => ({
  description: DESCRIPTION_BY_STYLE[style],
  title:
    TITLE_BY_STYLE_AND_FINISH[style][finish] ??
    TITLE_BY_STYLE_AND_FINISH[style][RingFinishEnum.Silver]!,
});

export default getPdpWizardSeoMetadata;
